import { EmailInput } from "./EmailInput";
import { PasswordInput } from "./PasswordInput";
import { SocialLoginButtons } from "./SocialLoginButtons";
import { FormDivider } from "./FormDivider";
import { StayLoggedIn } from "./StayLoggedIn";
import { RegisterLink } from "./RegisterLink";
import { SubmitButton } from "./SubmitButton";
import { useAuthForm } from "./useAuthForm";

interface AuthFormProps {
  mode: "login" | "register";
  onEmailChange?: (email: string) => void;
}

export function AuthForm({ mode, onEmailChange }: AuthFormProps) {
  const {
    email,
    emailError,
    password,
    stayLoggedIn,
    isLoading,
    handleEmailBlur,
    handleEmailChange,
    setPassword,
    setStayLoggedIn,
    handleSubmit,
  } = useAuthForm(mode, onEmailChange);

  return (
    <div className="space-y-6">
      <form onSubmit={handleSubmit} className="space-y-4">
        <EmailInput
          email={email}
          emailError={emailError}
          onChange={handleEmailChange}
          onBlur={handleEmailBlur}
        />

        <PasswordInput
          password={password}
          onChange={setPassword}
          mode={mode}
        />

        {mode === "login" && (
          <StayLoggedIn
            checked={stayLoggedIn}
            onCheckedChange={setStayLoggedIn}
          />
        )}

        <SubmitButton isLoading={isLoading} mode={mode} />
      </form>

      <FormDivider />

      <SocialLoginButtons mode={mode} />

      {mode === "register" && <RegisterLink />}
    </div>
  );
}